import styled from 'styled-components'
import { fontWeights } from '@/features/shared/styles/typography'

export const PromotionalCreditTerms = () => (
  <>
    <Asterisk>*</Asterisk>
    <SeeOffersLink
      href="https://www.shipt.com/promotional-credit-terms/"
      target="_blank"
      rel="noopener noreferrer"
    >
      See offer details.
    </SeeOffersLink>
    <span>
      {' '}
      Restrictions apply. Pricing, promotions, and availability may vary by store and location.
    </span>
  </>
)

const Asterisk = styled.span`
  font-weight: ${fontWeights.semibold};
`
const SeeOffersLink = styled.a`
  font-weight: ${fontWeights.semibold};
  color: ${({ theme }) => theme.gray400};
`
